import { AuthenticationActionTypes, AuthenticationActions } from './login.actions';
import { IUserAuth, IExternalData, IFormConfiguration } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    loggedIn: boolean;
    user: IUserAuth | null;
    externalProfile: IExternalData | null;
    formConfig: IFormConfiguration[] | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    loggedIn: false,
    user: null,
    externalProfile: null,
    formConfig: null
};

export function reducer(state = initialState, action: AuthenticationActions): State {
    switch (action.type) {

        case AuthenticationActionTypes.LoadAuthenticationState: {
            return {
                ...state,
                error: null,
                pending: false,
                loggedIn: false
            };
        }

        case AuthenticationActionTypes.LoadAuthenticationStateSuccess: {
            return {
                ...state,
                error: null,
                pending: false,
                loggedIn: true,
                user: action.payload
            };
        }

        case AuthenticationActionTypes.LoadAuthenticationStateFail: {
            return {
                ...state,
                error: action.payload,
                loggedIn: false,
                pending: false
            };
        }


        case AuthenticationActionTypes.LoadAuthenticationStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case AuthenticationActionTypes.LoadExternalProfileStateSuccess: {
            return {
                ...state,
                externalProfile: action.payload
            }
        }

        case AuthenticationActionTypes.LoadFormConfigStateSuccess: {
            return {
                ...state,
                formConfig: action.payload
            }
        }

        case AuthenticationActionTypes.Login:

        case AuthenticationActionTypes.GoogleLogin: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case AuthenticationActionTypes.AuthenticationRedirect: {
            return {
                ...state,
                error: null,
                pending: false,
                loggedIn: true,
            };
        }

        case AuthenticationActionTypes.GoogleLoginSuccess: {
            return {
                ...state,
                error: null,
                pending: false,
                loggedIn: false,
                user: action.payload
            };
        }

        case AuthenticationActionTypes.GoogleLoginFailure: {
            return {
                ...state,
                error: action.payload,
                loggedIn: false,
                pending: false
            };
        }

        case AuthenticationActionTypes.LoginSuccess: {
            return {
                ...state,
                error: null,
                pending: false,
                loggedIn: true,
                user: action.payload
            };
        }

        case AuthenticationActionTypes.RegisterGoogle: {
            return {
                ...state,
                error: null,
                loggedIn: false,
                pending: false
            };
        }

        case AuthenticationActionTypes.LoginFailure: {
            return {
                ...state,
                error: action.payload,
                loggedIn: false,
                pending: false
            };
        }

        case AuthenticationActionTypes.LoginErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case AuthenticationActionTypes.Logout: 
        // {
        //     return initialState;
        // }
        case AuthenticationActionTypes.LoginRedirect:
        case AuthenticationActionTypes.PostLogout: {
            return initialState;
        }

        case AuthenticationActionTypes.LoadFormOrProfileStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        // case AuthenticationActionTypes.Logout: {
        //     return {
        //         ...state,
        //         error: null,
        //         pending: true,
        //     };
        // }

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getLoggedIn = (state: State) => state.loggedIn;
export const getUser = (state: State) => state.user;
export const getExternalProfile = (state: State) => state.externalProfile;
export const getFormConfigs = (state: State) =>
    state.formConfig;